module.exports = __webpack_public_path__ + "img/linkedin.1b964be3.svg";